import React from 'react';

export const pageMeta = {
  "name": "JS String Reference",
  "link": "/javascript/strings/reference"
};

export default function JavascriptStringsReference() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS String Reference</h2>
      <p>Route: /javascript/strings/reference</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
